import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { ModalVentasComponent } from 'src/app/reporte/modal-ventas/modal-ventas.component';
import { Router, RouterLink } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { EditEmpresaService } from 'src/app/empresa/services/edit-empresa.service';
import { ComercializadorService } from 'src/app/empresa/services/comercializador.service';
import { CargaEmpresasService } from 'src/app/services/carga-empresas.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RegistroService } from '../../../registro.service';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import {
    ModalPeriodoComponent,
    PeriodoSeleccionadoModal,
} from '../modal-periodo/modal-periodo.component';
import { mensajeCertificado } from 'src/app/reporte/assets/dataMensaje';

@Component({
    selector: 'app-reporte-ventas-comercializadores',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        RouterLink,
        ButtonComponent,
        ModalPeriodoComponent,
    ],
    templateUrl: './reporte-ventas-comercializadores.component.html',
    styleUrls: ['./reporte-ventas-comercializadores.component.css'],
})
export class ReporteVentasComercializadores implements OnInit {
    years: number[] = [];
    months: { value: number; name: string }[] = [
        { value: 1, name: 'Enero' },
        { value: 2, name: 'Febrero' },
        { value: 3, name: 'Marzo' },
        { value: 4, name: 'Abril' },
        { value: 5, name: 'Mayo' },
        { value: 6, name: 'Junio' },
        { value: 7, name: 'Julio' },
        { value: 8, name: 'Agosto' },
        { value: 9, name: 'Septiembre' },
        { value: 10, name: 'Octubre' },
        { value: 11, name: 'Noviembre' },
        { value: 12, name: 'Diciembre' },
    ];
    trimestres: { value: string; name: string }[] = [
        { value: '1', name: 'Enero - Marzo' },
        { value: '2', name: 'Abril - Junio' },
        { value: '3', name: 'Julio - Septiembre' },
        { value: '4', name: 'Octubre - Diciembre' },
    ];
    semestres: { value: string; name: string }[] = [
        { value: '1', name: 'Enero - Junio' },
        { value: '2', name: 'Julio - Diciembre' },
    ];
    selectedSemestre: string = '1';

    reports: any[];
    selectedFile: File | undefined;

    filesend: boolean;
    fileUploaded: boolean;
    accessToken = '';
    selectedYear: number;
    selectedMonth: number;
    selectedTrimestre: string;
    empresaSeleccionada: string;
    tamanoComercializador: string | null = null;
    periodoName: string;

    private apiUrl: string = environment.apiSiriUrl;
    @ViewChild('reporteIndividual', { static: false })
    modalVentas: ModalVentasComponent;
    @ViewChild('modalLoadReport') modalLoadReport: ElementRef;
    @ViewChild(ModalPeriodoComponent)
    modalVentasManual: ModalPeriodoComponent;
    lastReport: any;
    showCertificados = false;

    get esGrande(): boolean {
        return this.tamanoComercializador?.toLowerCase() === 'grande';
    }

    get esMediano(): boolean {
        return this.tamanoComercializador?.toLowerCase() === 'mediano';
    }

    get esPequeno(): boolean {
        return this.tamanoComercializador?.toLowerCase() === 'pequeño';
    }

    showCertificates() {
        this.showCertificados = true;
    }

    constructor(
        private router: Router,
        private el: ElementRef,
        private modalService: NgbModal,
        private keycloakService: KeycloakService,
        private http: HttpClient,
        private editarService: EditEmpresaService,
        private registroService: RegistroService,
        private cargaEmpresasService: CargaEmpresasService,
        private comercializadorService: ComercializadorService,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    async ngOnInit() {
        this.empresaSeleccionada = await firstValueFrom(
            this.cargaEmpresasService.obtenerEmpresaSeleccionada()
        );

        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        this.selectedYear = currentYear;
        this.selectedMonth = currentMonth;
        this.selectedTrimestre = '1';

        this.years = [2025, 2026];

        const empresaId = this.registroService.empresaSelected;
        if (empresaId) {
            try {
                const comercializadorData = await firstValueFrom(
                    this.comercializadorService.findByAgenteVigiladoId(
                        +empresaId
                    )
                );
                this.tamanoComercializador =
                    comercializadorData?.tamanoComercializador ||
                    comercializadorData?.tamano_comercializador ||
                    null;
            } catch (error) {
                console.error(
                    'Error al obtener clasificación del comercializador:',
                    error
                );
            }
        }

        const periodosPorTamaño: Record<string, string> = {
            Grande: 'Mes',
            Mediano: 'Trimestre',
            Pequeño: 'Semestre',
        };

        this.periodoName =
            periodosPorTamaño[this.tamanoComercializador] || this.periodoName;

        this.historyReport();

        this.keycloakService.getToken().then((token) => {
            this.accessToken = token;
        });
        const idReporteGuardado: any =
            this.registroService.listaReportesGuardados.find(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa ===
                    this.registroService.empresaSelected
            );
        this.ultimoObjetoCreado = idReporteGuardado;
        this.translate
            .get('reporte.alertaIngreso')
            .subscribe((translatedText: string) => {
                Swal.fire('Recuerda', translatedText, 'info');
            });
    }

    historyReport() {
        let periodo: string;
        if (this.esGrande) {
            periodo = String(this.selectedMonth);
        } else if (this.esMediano) {
            periodo = 'T' + this.selectedTrimestre;
        } else if (this.esPequeno) {
            periodo = 'S' + this.selectedSemestre;
        } else {
            return;
        }

        this.http
            .get(
                `${this.apiUrl}reporte/empresa-actual/${this.registroService.empresaSelected}/${this.selectedYear}/${periodo}?state=Finalizado`
            )
            .subscribe(
                (response: any[]) => {
                    if (response.length > 0) {
                        response.sort(
                            (a, b) =>
                                new Date(b.fechaRegistro).getTime() -
                                new Date(a.fechaRegistro).getTime()
                        );
                        ///// Parseo de Periodo 1-12,1S,2S,1T,2T,3T,4T
                        response = response.map((r) => ({
                            ...r,
                            periodo: this.formatearPeriodo(r.periodo),
                            tamanoComercializador: this.tamanoComercializador,
                        }));
                        this.lastReport = response[0];
                    } else {
                        this.lastReport = {};
                    }
                    this.reports = response;
                },
                (error) => {
                    console.error('Error al consultar los reportes', error);
                }
            );
    }

    private formatearPeriodo(periodo: string): string {
        const meses: { [key: string]: string } = {
            '1': 'Enero',
            '2': 'Febrero',
            '3': 'Marzo',
            '4': 'Abril',
            '5': 'Mayo',
            '6': 'Junio',
            '7': 'Julio',
            '8': 'Agosto',
            '9': 'Septiembre',
            '10': 'Octubre',
            '11': 'Noviembre',
            '12': 'Diciembre',
        };

        // Meses
        if (meses[periodo]) {
            return meses[periodo];
        }

        // Semestres
        if (periodo === 'S1') return 'Enero - Junio';
        if (periodo === 'S2') return 'Julio - Diciembre';

        // Trimestres
        if (periodo === 'T1') return 'Enero - Marzo';
        if (periodo === 'T2') return 'Abril - Junio';
        if (periodo === 'T3') return 'Julio - Septiembre';
        if (periodo === 'T4') return 'Octubre - Diciembre';

        return periodo; // fallback
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const allowedExtensions = /(\.xlsx)$/i;

            if (!allowedExtensions.exec(file.name)) {
                Swal.fire(
                    'Error con el archivo',
                    'Por favor, selecciona un archivo con extensión .xlsx',
                    'warning'
                );
                input.value = '';
            } else {
                this.selectedFile = file;
            }
        }
    }

    getFileSize(size: number): string {
        const fileSizeInKB = size / 1024;
        return fileSizeInKB.toFixed(2) + ' KB';
    }

    async downloadReport() {
        try {
            //Validar si el usuario descargo el instructivo de reportes
            const puedeContinuar = await this.validarDescargaInstructivo();

            if (!puedeContinuar) {
                return;
            }
            console.log(
                `${this.apiUrl}reporte/descargar-planilla/${this.registroService.nitEmpresaSelected}`
            );
            const responseBlob = await lastValueFrom(
                this.http.get(
                    `${this.apiUrl}reporte/descargar-planilla/${this.registroService.nitEmpresaSelected}`,
                    { responseType: 'blob' }
                )
            );

            saveAs(responseBlob, 'planilla-siriagro.xlsx');
        } catch (error: any) {
            if (error.status === 412 && error.error instanceof Blob) {
                const errorText = await error.error.text();
                let mensaje = 'Datos erróneos, revisa el archivo';

                try {
                    const errorJson = JSON.parse(errorText);
                    mensaje = errorJson.message || mensaje;
                } catch {
                    mensaje = errorText || mensaje;
                }

                Swal.fire({
                    title: 'No es posible descargar la plantilla',
                    text: mensaje,
                    icon: 'warning',
                });
            } else {
                console.error('Error al descargar la plantilla', error);
                throw error;
            }
        }
    }

    mostrarTexto() {
        this.translate
            .get('reporte.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    async openMassUploadModal(content: any) {
        //Validar si el usuario descargo el instructivo de reportes
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }
        this.filesend = false;
        this.fileUploaded = false;
        this.selectedFile = undefined;
        this.modalService.open(content);
    }

    saveMassUpload() {
        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            this.http
                .post(
                    `${this.apiUrl}reporte/carga-masiva/${this.registroService.empresaSelected}/${this.registroService.nitEmpresaSelected}/${this.registroService.correoCorporativo}`,
                    formData
                )
                .subscribe(
                    (response: any) => {
                        console.log('response ', response);
                        if (response.statusCode === 206) {
                            this.fileUploaded = true;
                            this.filesend = false;
                            Swal.fire(`${response.message}`, '', 'warning');
                        } else {
                            console.log('Archivo subido con éxito', response);
                            this.fileUploaded = false;
                            this.filesend = true;
                        }
                    },
                    (e) => {
                        this.filesend = false;
                        this.fileUploaded = false;
                        console.error('Error con archivo ', e);
                        if (e.error.statusCode == 412) {
                            this.fileUploaded = false;
                            this.filesend = false;
                            Swal.fire(
                                'Datos erróneos, revisa el archivo',
                                e.error.message,
                                'warning'
                            );
                            this.closeMassUploadModal();
                        } else if (typeof e.error.error === 'object') {
                            Swal.fire(
                                'Error al subir el archivo',
                                ' ',
                                'warning'
                            );
                        } else {
                            Swal.fire(
                                'Error al subir el archivo',
                                e.error.error,
                                'warning'
                            );
                        }
                        this.closeMassUploadModal();
                    }
                );
        }
    }

    replaceFile() {
        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);
            this.http
                .post(
                    `${this.apiUrl}reporte/carga-masiva/${this.registroService.empresaSelected}/${this.registroService.nitEmpresaSelected}/${this.registroService.correoCorporativo}?overwrite=true`,
                    formData
                )
                .subscribe(
                    (response: any) => {
                        this.fileUploaded = false;
                        this.filesend = true;
                    },
                    (e) => {
                        this.fileUploaded = false;
                        console.log(
                            'Error al subir el archivo reemplazo  ',
                            e.error
                        );
                        if (e.error.statusCode == 412) {
                            console.log('status 412 ');
                            this.fileUploaded = false;
                            this.filesend = false;
                            Swal.fire(
                                'Datos erróneos, revisa el archivo',
                                e.error.message,
                                'warning'
                            );
                            this.closeMassUploadModal();
                        } else if (e.error.statusCode === 401) {
                            Swal.fire({
                                title: 'Acción no permitida',
                                text: e.error.message,
                                icon: 'warning',
                                confirmButtonText: 'Aceptar',
                            }).then((result) => {
                                if (result.isConfirmed || result.isDismissed) {
                                    this.closeMassUploadModal();
                                }
                            });
                        } else if (typeof e.error.error === 'object') {
                            Swal.fire(
                                'Error al subir el archivo',
                                ' ',
                                'warning'
                            );
                        } else {
                            Swal.fire(
                                'Error al subir el archivo',
                                e.error.error,
                                'warning'
                            );
                        }
                        this.closeMassUploadModal();
                    }
                );
        }
    }

    closeMassUploadModal() {
        this.fileUploaded = false;
        this.modalService.dismissAll();
    }

    async descargarCertificado() {
        const url = `${this.apiUrl}certificado`;
        console.log('lastReport', this.lastReport);

        try {
            //Validar si el usuario descargo el instructivo de reportes
            const puedeContinuar = await this.validarDescargaInstructivo();

            if (!puedeContinuar) {
                return;
            }
            const empresaActual =
                await this.editarService.getEmpresaActual('agente-vigilado');
            const mensaje = mensajeCertificado(empresaActual, this.lastReport);

            const agenteVigilado = {
                mensaje: mensaje,
            };

            this.http
                .post(url, agenteVigilado, { responseType: 'blob' })
                .subscribe(
                    (blob: Blob) => {
                        saveAs(blob, 'certificado.pdf');
                    },
                    (error) => {
                        console.error(
                            'Error al descargar el certificado:',
                            error
                        );
                    }
                );
        } catch (error) {
            console.error(
                'Error al obtener la información de la empresa:',
                error
            );
        }
    }

    //Funciones carga manual

    ultimoObjetoCreado = false;

    async reporteManual() {
        //Validar si el usuario descargo el instructivo de reportes
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }
        if (this.modalVentasManual) {
            /** Fecha minima para reportar ventas e inventarios en agentes comercializadores */
            this.modalVentasManual.minDate = '2026-01-01';
            this.modalVentasManual.open();
        }
    }

    /** Emite el modal al confirmar periodo (mes / trimestre / semestre según tamaño). */
    onPeriodoSeleccionado(periodo: PeriodoSeleccionadoModal) {
        const queryParams: Record<string, string | number> = {
            year: periodo.year,
        };
        if (periodo.month) {
            queryParams['month'] = periodo.month.name;
            queryParams['monthNumber'] = periodo.month.number;
        } else if (periodo.quarter) {
            queryParams['month'] = periodo.quarter.name;
            queryParams['monthNumber'] = periodo.quarter.number;
        } else if (periodo.semester) {
            queryParams['month'] = periodo.semester.name;
            queryParams['monthNumber'] = periodo.semester.number;
        }
        this.router.navigate(['reporte-manual-comercializador'], {
            queryParams,
        });
    }

    async continuarReporte() {
        //Validar si el usuario descargo el instructivo de reportes
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }
        this.router.navigate([`reporte-manual-comercializador`]);
    }

    async irConsultaReportes() {
        const puedeContinuar = await this.validarDescargaInstructivo();

        if (!puedeContinuar) {
            return;
        }

        this.router.navigate(['/reporte-periodo-comercializador']);
    }

    async downloadInstructive() {
        try {
            const pdf = await lastValueFrom(
                this.http.get(`${this.apiUrl}reporte/descargar-instructivo`, {
                    responseType: 'blob',
                })
            );

            saveAs(pdf, 'Buenas_practicas_instructivo.pdf');
        } catch (error) {
            console.error('Error al descargar el instructivo', error);

            Swal.fire({
                title: 'Error',
                text: 'No fue posible descargar el instructivo. Inténtalo nuevamente más tarde.',
                icon: 'error',
            });
        }
    }

    async validarDescargaInstructivo(): Promise<boolean> {
        try {
            const descargoInstructivo = await lastValueFrom(
                this.http.get<boolean>(
                    `${this.apiUrl}reporte/validar-descarga-instructivo`
                )
            );

            if (!descargoInstructivo) {
                Swal.fire({
                    title: 'Atención',
                    text: 'Antes de acceder a estas funcionalidades, es necesario descargar el instructivo.',
                    icon: 'warning',
                });
            }

            return descargoInstructivo;
        } catch (error) {
            console.error(
                'Error al validar la descarga del instructivo',
                error
            );

            Swal.fire({
                title: 'Error',
                text: 'No fue posible validar la descarga del instructivo.',
                icon: 'error',
            });

            return false;
        }
    }
}
